import {
  useListAndSearchAllAccounts,
  useListPublicAccounts,
  AccountsApiListAndSearchAllAccountsRequest,
} from "@bn/api/apiv1";
import { useSharedPortfolioContext } from "@providers/SharedPortfolioProvider";

export const usePublicOrPrivateAccounts = (
  params: AccountsApiListAndSearchAllAccountsRequest = {}
) => {
  const { isSharedPortfolio, publicId } = useSharedPortfolioContext();

  const { data: accounts, ...rest } = useListAndSearchAllAccounts(params, {
    refetchOnWindowFocus: false,
    enabled: !isSharedPortfolio,
  });
  const { data: publicAccounts, ...publicRest } = useListPublicAccounts(
    {
      publicId: publicId!,
      ...params,
    },
    {
      refetchOnWindowFocus: false,
      enabled: isSharedPortfolio,
    }
  );

  return {
    accounts: isSharedPortfolio
      ? publicAccounts?.publicAccounts
      : accounts?.accounts,
    ...(isSharedPortfolio ? publicRest : rest),
  };
};
